import { z } from 'zod'

export const GetVolumeBreakdownsByExchangeQuery = z.object({
  date: z.string().date(),
  marketMakerId: z.string().nullish(),
  orderBook: z.string().nullish(),
  daysLookback: z.coerce.number().int().positive().nullish(),
})

export const GetVolumeBreakdownsQuery = GetVolumeBreakdownsByExchangeQuery.extend({
  exchangeId: z.string().nullish(),
})

export type GetVolumeBreakdownsQueryType = z.infer<typeof GetVolumeBreakdownsQuery>
export type GetVolumeBreakdownsByExchangeQueryType = z.infer<typeof GetVolumeBreakdownsByExchangeQuery>

const GetVolumeBreakdownsByExchangeEntry = z.object({
  exchangeId: z.string(),
  exchangeName: z.string(),
  maker: z.number().safe(),
  makerPercentage: z.number().safe(),
  makerTaker: z.number().safe(),
  makerTakerPercentage: z.number().safe(),
  taker: z.number().safe(),
  takerPercentage: z.number().safe(),
})

const GetVolumeBreakdownsEntry = GetVolumeBreakdownsByExchangeEntry.omit({
  exchangeId: true,
  exchangeName: true,
}).extend({
  allOthersMaker: z.number().safe(),
  allOthersMakerPercentage: z.number().safe(),
  allOthersMakerTaker: z.number().safe(),
  allOthersMakerTakerPercentage: z.number().safe(),
  allOthersTaker: z.number().safe(),
  allOthersTakerPercentage: z.number().safe(),
  overreportingMaker: z.number().safe(),
  overreportingTaker: z.number().safe(),
  overreportingMakerTaker: z.number().safe(),
  warnings: z
    .object({
      maker: z.boolean(),
      taker: z.boolean(),
      makerTaker: z.boolean(),
    })
    .nullable(),
})

export const GetVolumeBreakdownsByExchangeResult = z.array(GetVolumeBreakdownsByExchangeEntry)
export const GetVolumeBreakdownsResult = z.array(GetVolumeBreakdownsEntry)
